import { showToast } from './toastBoot';
import { toToastType, type ToastType } from './toastTypes';

// window.notify の実体。js.erb は型検査されないため、type はここで正規化する。
// js.erb を 2 引数に書き換える間（#19039）は bootstrap-notify 時代の 8 引数も受ける。
// デプロイ前から開いているタブ（古い pack）が新しい js.erb を受けても、新しい pack が古い js.erb を受けても崩れないようにするため。
// 8 引数のうち from/align/icon/animIn/animOut は使わない
type LegacyArgs = [
  title: string,
  message: string,
  from: string,
  align: string,
  icon: string,
  type: string,
  animIn: string,
  animOut: string,
];

export default function flashMessage(
  ...args: [message: string, type?: string] | LegacyArgs
) {
  // 3 個以上は 8 引数の並びとして読む。書き換え途中で後ろの引数が欠けても本文を残すため
  // （先頭の title を消した呼び出しは区別できない）。6 個に満たず type がないときは info になる
  if (args.length > 2) {
    const [title, message, , , , type] = args as LegacyArgs;
    showToast({ title, message, type: toToastType(type) });
    return;
  }
  const [message, type = 'info'] = args;
  showToast({ title: '', message, type: toToastType(type) });
}

export type FlashMessageType = ToastType;

export function simpleFlashMessage(
  message: string,
  type: FlashMessageType = 'info',
) {
  showToast({ title: '', message, type });
}
